export default __webpack_public_path__ + "static/media/117.0a3be1be.webp";